import { toast as reactToast } from 'react-toastify';

// Default options for all toasts - MUST include autoClose
const defaultToastOptions = {
  autoClose: 500,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
  closeButton: false,
  position: 'top-center',
  theme: 'colored',
};

// Wrapper functions that ensure autoClose is always set
export const toast = {
  success: (message, options = {}) => {
    // Force autoClose to be set, even if options override it
    const finalOptions = { ...defaultToastOptions, ...options, autoClose: options.autoClose !== undefined ? options.autoClose : 500 };
    return reactToast.success(message, finalOptions);
  },
  error: (message, options = {}) => {
    const finalOptions = { ...defaultToastOptions, ...options, autoClose: options.autoClose !== undefined ? options.autoClose : 500 };
    return reactToast.error(message, finalOptions);
  },
  info: (message, options = {}) => {
    const finalOptions = { ...defaultToastOptions, ...options, autoClose: options.autoClose !== undefined ? options.autoClose : 500 };
    return reactToast.info(message, finalOptions);
  },
  warning: (message, options = {}) => {
    const finalOptions = { ...defaultToastOptions, ...options, autoClose: options.autoClose !== undefined ? options.autoClose : 500 };
    return reactToast.warning(message, finalOptions);
  },
  default: (message, options = {}) => {
    const finalOptions = { ...defaultToastOptions, ...options, autoClose: options.autoClose !== undefined ? options.autoClose : 500 };
    return reactToast(message, finalOptions);
  },
  // Also export dismiss methods
  dismiss: reactToast.dismiss,
  isActive: reactToast.isActive,
};

export default toast;

